import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ApplicantsComponent from './ApplicantsComponent';
import TutorAssignmentComponent from './TutorAssignmentComponent';
import InternshipOffersComponent from './InternshipOffersComponet';
import { Badge, Tabs } from 'antd';
import TabPane from 'antd/es/tabs/TabPane';
import ConventionSignComponent from '../ConventionSignComponent';
import { Roles } from '../../Types/interfaces';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../Constants/queryKeys';
import { useUserOrganizations } from '../../hooks/useOrganizations';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import {
  useApplicationCount,
  useConventionsToBeSignedCount,
  useStudentCount,
} from '../../hooks/BadgeHooks/InternshipApplicationHooks';
import { EMPTY_ARRAY } from '../../Constants/constants';

const InternshipManagementComponent = (): React.ReactElement => {
  const loggedInUser = useCurrentUser();
  const [activeTab, setActiveTab] = useState('offers');
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { data: userOrganizations = EMPTY_ARRAY } = useUserOrganizations(
    loggedInUser?.id
  );

  const handleTabChange = (key: string): void => {
    setActiveTab(key);
  };

  const { data: applicationCount = 0 } = useApplicationCount(userOrganizations);
  const { data: studentCount = 0 } = useStudentCount(userOrganizations);
  const { data: conventionsToBeSignedCount = 0 } =
    useConventionsToBeSignedCount(userOrganizations);

  return (
    <Tabs
      activeKey={activeTab}
      onChange={handleTabChange}
      tabBarGutter={16}
      centered
      type="card"
    >
      <TabPane tab={t('internshipManComp.addEditOffers')} key="offers">
        <InternshipOffersComponent />
      </TabPane>
      <TabPane
        tab={
          <Badge count={applicationCount} overflowCount={9} size="small">
            {t('internshipManComp.studPend')}
          </Badge>
        }
        key="applicants"
      >
        <ApplicantsComponent />
      </TabPane>
      <TabPane
        tab={
          <Badge count={studentCount} overflowCount={9} size="small">
            {t('internshipManComp.assTut')}
          </Badge>
        }
        key="tutors"
      >
        <TutorAssignmentComponent
          recount={async () =>
            await queryClient.invalidateQueries({
              queryKey: QUERY_KEYS.STUDENT_COUNT,
            })
          }
        />
      </TabPane>
      <TabPane
        tab={
          <Badge
            count={conventionsToBeSignedCount}
            overflowCount={9}
            size="small"
          >
            {t('internshipManComp.conv')}
          </Badge>
        }
        key="conventions"
      >
        <ConventionSignComponent
          menuGroup="OrganizationRepresentative"
          filterByStudyYear={true}
          enableDownload={true}
          recount={async () => {
            await queryClient.invalidateQueries({
              queryKey: QUERY_KEYS.CONVENTIONS_TO_BE_SIGNED_COUNT,
            });
            await queryClient.invalidateQueries({
              queryKey: [
                ...QUERY_KEYS.INTERNSHIP_PROCESSES_BY_USER_ID,
                loggedInUser?.id,
              ],
            });
            console.log('INVALIDALTAM');
          }}
          role={Roles.OrganizationRepresentative}
        />
      </TabPane>
    </Tabs>
  );
};

export default InternshipManagementComponent;
